import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import TopNavBar from './TopNavBar';
import UserSidebar from './UserSidebar';

/** Shell for the field-representative "User Flow": shared top bar + user sidebar. */
export default function UserLayout() {
  const [navOpen, setNavOpen] = useState(false);

  return (
    <div className="min-h-screen bg-brand-bg">
      <TopNavBar onMenuClick={() => setNavOpen(true)} />
      <UserSidebar open={navOpen} onClose={() => setNavOpen(false)} />
      <main className="mt-16 max-w-[1440px] p-4 sm:p-6 lg:ml-[280px]">
        <Outlet />
      </main>
    </div>
  );
}
